import { UploadOutlined } from "@ant-design/icons";
import { UploadProps } from "antd";
import { t } from "i18next";
import React from "react";
import {
  PlmUploader,
  PropsPlmUploaderRender,
} from "src/components/PlmUploader";
import { AttrImageCarouselProps } from "src/common/attrEdit/components/ZAttrImageCarousel";
import styles from "./ImageCarousel.module.less";
import { ImageCarouselInner } from "./ImageCarouselInner";
import { ImageCarouselScroll } from "./ImageCarouselScroll";
import { SolidButton } from "../buttons/SolidButton";

type PropsImageCarousel = AttrImageCarouselProps &
  Omit<UploadProps, "fileList" | "onChange"> & {
    value?: string[];
    onChange?(v: string[] | undefined): void;
    readOnly?: boolean;
  };

export const ImageCarousel: React.FC<PropsImageCarousel> = (props) => {
  const { value, multiple, imageHeight, readOnly } = props;
  return (
    <PlmUploader
      {...props}
      isImage
      render={(renderProps) => (
        <Inner
          value={value}
          multiple={multiple}
          imageHeight={imageHeight}
          renderProps={renderProps}
          readOnly={readOnly}
        />
      )}
    />
  );
};

interface PropsInner {
  value?: string[];
  multiple?: boolean;
  imageHeight?: number;
  renderProps: PropsPlmUploaderRender;
  readOnly?: boolean;
}

const Inner: React.FC<PropsInner> = ({
  value,
  multiple,
  imageHeight,
  renderProps,
  readOnly,
}) => {
  const { fileList, disabled, handleRemove, setIsModalOpen } = renderProps;
  const [isMultiMode, setIsMultiMode] = React.useState(false);
  const [activeImage, setActiveImage] = React.useState(0);

  React.useEffect(() => {
    const guids: string[] = value ?? [];
    if (guids.length > 1 && multiple) {
      setIsMultiMode(true);
    } else {
      setIsMultiMode(false);
      setActiveImage(0);
    }
  }, [value]);

  const onDelete = () => {
    const file = fileList[activeImage];
    if (!file) return;
    handleRemove(file);
    const newActiveImage = activeImage - 1;
    if (newActiveImage >= 0) {
      setActiveImage(newActiveImage);
    }
  };

  return (
    <div className={styles.imageCarousel}>
      {fileList[activeImage] && (
        <ImageCarouselInner
          onDelete={onDelete}
          disabled={disabled ?? false}
          height={imageHeight}
          fileList={fileList}
          currentImageIndex={activeImage}
          onImageSelect={setActiveImage}
        />
      )}
      {isMultiMode && (
        <ImageCarouselScroll
          fileList={fileList}
          onImageSelect={setActiveImage}
          currentImageIndex={activeImage}
        />
      )}
      {!readOnly && (
        <SolidButton
          onClick={() => setIsModalOpen(true)}
          disabled={disabled}
          className={styles.imageUploadButton}
          icon={fileList.length > 0 ? undefined : <UploadOutlined />}
        >
          {fileList.length > 0 ? t("Modify") : t("Upload")}
        </SolidButton>
      )}
    </div>
  );
};
